var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo-img",class:{small:_vm.small},attrs:{"src":_vm.logoSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }